export const ratingIcons = {
    positive: `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="white" stroke="#4CAF50" stroke-width="2"/>
                  <circle cx="9" cy="10" r="1.5" fill="#4CAF50"/>
                  <circle cx="15" cy="10" r="1.5" fill="#4CAF50"/>
                  <path d="M8.5 14.5c1.75 2 5.25 2 7 0" stroke="#4CAF50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
    
    neutral: `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="white" stroke="#FFEB3B" stroke-width="2"/>
                  <circle cx="9" cy="10" r="1.5" fill="#FFEB3B"/>
                  <circle cx="15" cy="10" r="1.5" fill="#FFEB3B"/>
                  <path d="M8.5 14h7" stroke="#FFEB3B" stroke-width="2" stroke-linecap="round"/>
                </svg>`,
    
    negative: `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="white" stroke="#F44336" stroke-width="2"/>
                  <circle cx="9" cy="10" r="1.5" fill="#F44336"/>
                  <circle cx="15" cy="10" r="1.5" fill="#F44336"/>
                  <path d="M8.5 15.5c1.75-2 5.25-2 7 0" stroke="#F44336" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`
  };
  